export const DefaultAgTechUser: AgTechUser = {
    id: '',
    name: '',
    username: '',
    token: '',
    role: [],
    permissions: []
};

export type AgTechUser = {
    id: string,
    name: string,
    username: string,
    token: string,
    role: string[],
    // Values of the "permission" claim issued alongside "role" - see ROLES_AND_PERMISSIONS.md
    // in the SalesProject repo for the taxonomy. Same source as `role` (baked into the OIDC
    // token via DAT.Accounts' ProfileService), not a separate API call.
    permissions: string[]
};

// DAT.Platform's DefaultRoles.OperationAdmin ("OA") - an operation-level role, not a per-application
// permission, issued into every DAT app's token by DAT.Accounts' ProfileService. Bypasses every
// permission check, mirroring SalesProject.API's ResourcePermissionAuthorizationHandler. See
// ROLES_AND_PERMISSIONS.md "Roles that bypass permissions" in the SalesProject repo for why.
const OperationAdminRole = 'OA';

export const userHasPermission = (user: AgTechUser, permission: string): boolean =>
    user.role.includes(OperationAdminRole) || user.permissions.includes(permission);

export const AgTechIdentityBaseURL = process.env.REACT_APP_AUTHORITY + '';

export const AuthTokenStorageKey = 'auth_token';
export const RefreshTokenStorageKey = 'refresh_token';